export enum Role {
  Admin = "ADMIN",
  Employee = "EMPLOYEE",
  RECEPTIONNISTE = "RECEPTIONNISTE",
  MANAGER = "MANAGER",
  COMPTABLE = "COMPTABLE",
  CLIENT = "CLIENT",
  SUPPERVISEUR = "SUPPERVISEUR",
  GESTIONNAIRE = "GESTIONNAIRE",
  ADMIN_GROUP_HOTEL = "ADMIN_GROUP_HOTEL",
  ADMIN_HOTEL = "ADMIN_HOTEL",
  ADMIN_APPART_HOTEL = "ADMIN_APPART_HOTEL",
  ADMIN_GROUP_BIEN = "ADMIN_GROUP_BIEN",
  CONCIERGE = "CONCIERGE",
  CHARGE_OPERATIONS = "CHARGE_OPERATIONS",
  DEFAULT = "DEFAULT",
}
